import { AppConstants } from '@core-lib/config';

export function alphanumericSort(a: string, b: string): 1 | 0 | -1 {
	const aAlpha = a.replace(AppConstants.REGEX.startAlpha, '');
	const bAlpha = b.replace(AppConstants.REGEX.startAlpha, '');

	if (aAlpha === bAlpha) {
		const aNumeric = parseInt(a.replace(AppConstants.REGEX.startNumeric, ''), 10);
		const bNumeric = parseInt(b.replace(AppConstants.REGEX.startNumeric, ''), 10);
		return aNumeric === bNumeric ? 0 : aNumeric > bNumeric ? 1 : -1;
	} else {
		return aAlpha > bAlpha ? 1 : -1;
	}
}
